import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import {z} from "zod";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('de-AT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

export const formatDateTime = (dateString: string) => {
  const date = new Date(dateString);
  return {
    date: date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }),
    time: date.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit'
    })
  };
};

export const dateStringSchema = z.string().refine((val) => {
  const date = new Date(val);
  return !isNaN(date.getTime());
}, "Must be a valid date string")

/**
 * Formats race time (in seconds) to MM:SS.HH format
 * @param time - Time in seconds (e.g., 123.45 for 2:03.45)
 * @returns Formatted time string or '-' if no time provided
 */
export const formatRaceTime = (time?: number | undefined | null) => {
  if (!time) return '-';
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  const hundredths = Math.floor((time % 1) * 100);
  return `${minutes}:${seconds.toString().padStart(2, '0')}.${hundredths.toString().padStart(2, '0')}`;
};

/**
 * Parses a race time string into seconds
 * @param timeStr - Time string in MM:SS.HH format
 * @returns Time in seconds or undefined if invalid format
 */
export const parseRaceTime = (timeStr: string): number | undefined => {
  const match = timeStr.match(/^(\d+):(\d{2})\.(\d{2})$/);
  if (!match) return undefined;

  const [, minutes, seconds, hundredths] = match;
  return parseInt(minutes) * 60 + parseInt(seconds) + parseInt(hundredths) / 100;
};
